import { baseMSWAssessment } from '../validations/msw-assessment/v1';
const shape = baseMSWAssessment.shape;
export const visitsFields = [
    { key: 'numberOfVisits', field: shape.numberOfVisits },
    { key: 'visits', field: shape.visits, variant: 'list' },
];
export const problemFields = [
    { key: 'physicalStatus', field: shape.physicalStatus },
    { key: 'mentalStatus', field: shape.mentalStatus },
    { key: 'emotionalStatus', field: shape.emotionalStatus },
    { key: 'funcStatus', field: shape.funcStatus },
    { key: 'healthStatus', field: shape.healthStatus },
    { key: 'financialStatus', field: shape.financialStatus },
    { key: 'vulnerable', field: shape.vulnerable },
];
export const environmentalFields = [
    { key: 'appropriateness', field: shape.appropriateness },
    { key: 'livingEnv', field: shape.livingEnv },
    { key: 'econIssues', field: shape.econIssues },
    { key: 'envOther', field: shape.envOther },
];
export const outcomeFields = [
    { key: 'desiredOutcome', field: shape.desiredOutcome },
    { key: 'mswGoal', field: shape.mswGoal },
    { key: 'followUpPlan', field: shape.followUpPlan },
];
